import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Image from 'next/image';
import React from 'react';
import Slider from 'react-slick';

import playBtn from '@/assets/images/icons/video-play.svg';
import { VideoSettings } from '@/utils/constants/carousel/dgSettings/videosSettings';
import { LearnVideos } from '@/utils/constants/digital-gold';

export const VideosSection = () => {
  return (
    // <section className="bg bg--ultraLight">
    //   <div className="home__video">
    //     <div className="container p-0">
    //       <h2 className="section__title-small text--bold text--black">
    //         Learn more through our videos
    //       </h2>
    //     </div>

    // dg last videos
    // <div className="home__video--slider blog-cards-container home-scheme-margin testimonial-container">
    //   <Slider {...videoSettings} className="test-carousel2">
    //     {LearnVideos.map((eachItem, index) => (
    //       <div key={index} className="item testimonial-item">
    //         <div className="video__card">
    //           <div className="video__media">
    //             <video
    //               poster={eachItem.thumbnail}
    //               // autoplay="autoplay"
    //               autoPlay={false}
    //             >
    //               <source src={eachItem.videoSource} type="video/mp4" />
    //             </video>
    //             {/* with yt emebeded vidoes and remove below play button */}
    //             {/* <iframe
    //                   className="iframe-video"
    //                   src={`https://www.youtube.com/embed/${eachItem.urlLink}`}
    //                   loading="lazy"
    //                   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    //                   allowFullScreen={true}
    //                   frameBorder={0}

    //                 ></iframe> */}
    //             <div className="video__control">
    //               <button type="button" className="play-button">
    //                 <Image
    // style={{ color: undefined }}
    //                   className="img-fluid"
    //                   src={playBtn}
    //                   alt="play button"
    //                 />
    //               </button>
    //             </div>
    //           </div>
    //           <div className="video__footer">
    //             <p className="text--black text--bold title">{eachItem.title}</p>
    //             <p className="text--gray text--regular desc">{eachItem.desc}</p>
    //           </div>
    //         </div>
    //       </div>
    //     ))}
    //   </Slider>
    // </div>

    <div className="home__customer--slider">
      <Slider {...VideoSettings}>
        {LearnVideos.map((eachItem, index) => (
          <div key={index} className="item item-test-new testimonial-item">
            <div className="video__card">
              <div className="video__media">
                <video
                  poster={eachItem.thumbnail}
                  // autoplay="autoplay"
                  autoPlay={false}
                >
                  <source src={eachItem.videoSource} type="video/mp4" />
                </video>
                {/* with yt emebeded vidoes and remove below play button */}
                {/* <iframe
                      className="iframe-video"
                      src={`https://www.youtube.com/embed/${eachItem.urlLink}`}
                      loading="lazy"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen={true}
                      frameBorder={0}
                      
                    ></iframe> */}
                <div className="video__control">
                  <button type="button" className="play-button">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={playBtn}
                      alt="play button"
                    />
                  </button>
                </div>
              </div>
              <div className="video__footer">
                <p className="text--black text--bold title">{eachItem.title}</p>
                <p className="text--gray text--regular desc">{eachItem.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>

    //   </div>
    // </section>
  );
};
